<template>
    <Transition>
        <div
            v-if="showPopup"
            class="fixed inset-x-4 bottom-4 z-50 w-[350px] rounded-xl border bg-white p-8 shadow lg:bottom-10 lg:left-10 lg:top-auto"
        >
            <div class="space-y-6">
                <h2 class="text-lg font-medium">{{ $t('Consent to the use of cookies') }}</h2>

                <p v-if="$page.props.locale == 'fr'" class="text-sm text-gray-800">
                    Le site web utilise des cookies essentiels pour garantir son bon fonctionnement et assurer la sécurité de votre
                    navigation. En plus de ces cookies indispensables, Le site utlise également d'autres cookies et technologies facultatifs
                    pour améliorer votre expérience, personnaliser le contenu et analyser l'utilisation du site. En cliquant sur « Essentiel
                    seulement », certaines fonctionnalités du site pourraient ne pas être disponibles. Pour en savoir plus sur la manière
                    dont nous utilisons les cookies, consultez
                    <a href="/politique-de-confidentialité" class="link">notre politique de confidentialité et d'utilisation</a>
                    .
                </p>

                <p v-if="$page.props.locale == 'en'" class="text-sm text-gray-800">
                    Our website uses necessary cookies to ensure its proper functioning and your secure browsing experience. In addition to
                    these essential cookies, we also use other optional cookies and technologies to enhance your experience, personalize
                    content, and analyze site usage. By clicking "Required only," certain features of our website might not be available. To
                    learn more about our privacy policy and how we use cookies, please refer to
                    <a href="/politique-de-confidentialité" class="link">our dedicated privacy page</a>
                    .
                </p>

                <div class="space-y-2">
                    <button class="button block w-full text-center" @click.prevent="acceptAll">{{ $t('Accept all') }}</button>
                    <button class="button block w-full text-center" @click.prevent="acceptRequired">{{ $t('Required only') }}</button>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
    import { onMounted, ref } from 'vue';
    import { useCookieConsent } from '../useCookieConsent';

    const { consent } = useCookieConsent();

    const showPopup = ref(false);

    onMounted(() => {
        setTimeout(() => {
            showPopup.value = consent != 'accept-all' && consent != 'accept-required';
        }, 1000);

        window.bus.on('show-cookie-consent', () => {
            showPopup.value = true;
        });
    });

    function acceptAll() {
        axios.post('/cookie-consent/accept-all').then(response => {
            window.location.reload();
        });
    }

    function acceptRequired() {
        axios.post('/cookie-consent/accept-required').then(response => {
            window.location.reload();
        });
    }
</script>

<style>
    .v-enter-active,
    .v-leave-active {
        transform: translateY(0%);
        transition: all 0.5s ease;
        opacity: 1;
    }

    .v-enter-from,
    .v-leave-to {
        transform: translateY(50%);
        opacity: 0.5;
    }
</style>
